import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { selectConfigration } from "../../../redux/slices/configrationSlice";
import LookupTable from "../../../redux/models/lookupTable";
import K from "../../../utilities/constants";

const DEFAULT_STATUS_NAMES = [K.JobStatusName.Open, K.JobStatusName.Pending];

export const useDefaultJobStatusIds = () => {
  const configration = useSelector(selectConfigration);
  const [defaultStatusIds, setDefaultStatusIds] = useState([]);

  useEffect(() => {
    const fetchDefaultStatusIds = async () => {
      let jobStatuses = configration?.lookup?.[K.Redux.JobStatus] || [];

      if (jobStatuses.length === 0) {
        try {
          jobStatuses = await LookupTable.getJobStatuses(false);
        } catch (err) {
          console.error("Failed to fetch job statuses:", err);
          return;
        }
      }

      const defaultStatuses = jobStatuses.filter(({ name }) =>
        DEFAULT_STATUS_NAMES.some(
          (statusName) => name?.toLowerCase() === statusName?.toLowerCase(),
        ),
      );
      setDefaultStatusIds(defaultStatuses.map(({ id }) => id));
    };

    fetchDefaultStatusIds();
  }, [configration?.lookup?.[K.Redux.JobStatus]]);

  return defaultStatusIds;
};
